import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { LoginService } from '../../common/services/Login.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { DomSanitizer } from '@angular/platform-browser';
import { OpenLinkById } from '../../common/services/openlinkbyid';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notice-to-constituents',
  templateUrl: './notice-to-constituents.component.html',
  styleUrls: ['./notice-to-constituents.component.css']
})
export class NoticeToConstituentsComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    public loginService: LoginService,
    private graphQlService: GraphqlService,
    private sanitizer: DomSanitizer,
    private openlink: OpenLinkById, private route: Router) {
  }
  ntc_header;
  ntc_body;
  ntc_link;
  content_initialized = false;

  @Input() IsRightPanel:boolean=false;
  @Output() myEvent = new EventEmitter<string>();
  ngOnInit(): void {
    // this.IsRightPanel=this.commonDataService.showRightPanel.getValue();
   
    this.commonDataService.showLoader.next(true);
    this.getNoticetoConstituentslabels();
  }
  getNoticetoConstituentslabels() {


    this.graphQlService.getNoticetoConstituentslabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.ntc_header = labels.filter(x => x.key == "ntc_header").map(y => y.value);
        this.ntc_body = labels.filter(x => x.key == "ntc-body").map(y => y.value);
        this.ntc_body = this.sanitizer.bypassSecurityTrustHtml(this.ntc_body);
        this.ntc_link = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "ntc-link").map(y => y.value));
        this.content_initialized = true;

        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });


  }

  openLinkById(event) {
    this.myEvent.emit();
    this.openlink.openLinkById(event,true);
  }

}
